<template>
  <v-btn
    v-bind="$props"
    v-on="$listeners"
    icon
    plain
    @click="$emit('click:progress-backward-item', $attrs.item)"
    >
    <slot>
    <v-icon color="orange">{{ $icons.applicantProgressBackward }}</v-icon>
    </slot>
  </v-btn>
</template>

<script>
import { VBtn } from 'vuetify/lib'

export default {
  name: 'ProgressBackwardItemAction',
  extends: VBtn,
}
</script>

